var map = {
	"./Input/close.svg": 294,
	"./Input/search.svg": 295,
	"./Landing.svg": 320,
	"./android.svg": 568,
	"./angle-left.svg": 203,
	"./angle-right.svg": 321,
	"./available.svg": 312,
	"./avatar.svg": 569,
	"./bars.svg": 322,
	"./checkedBox.svg": 323,
	"./cifrao.svg": 324,
	"./cifraoAzul.svg": 301,
	"./clicked.svg": 570,
	"./closed-mail.svg": 325,
	"./closedMail.svg": 571,
	"./confirm.svg": 310,
	"./copia.svg": 572,
	"./customer-cloud.svg": 573,
	"./dispatchedLetter.svg": 574,
	"./dropIcon.svg": 575,
	"./editIconChanged.svg": 326,
	"./editar.svg": 307,
	"./estrela.svg": 327,
	"./excluir.svg": 302,
	"./eye.svg": 328,
	"./filtroDias/07Bar.svg": 576,
	"./filtroDias/15Bar.svg": 577,
	"./filtroDias/180Bar.svg": 578,
	"./filtroDias/30Bar.svg": 579,
	"./filtroDias/365Bar.svg": 580,
	"./gear.svg": 581,
	"./helpIcon.svg": 329,
	"./iconFile.svg": 297,
	"./intelligent-store-white.svg": 582,
	"./intelligent-store.svg": 293,
	"./interrogacao.svg": 308,
	"./ios.svg": 583,
	"./layers-white.svg": 274,
	"./layout-blue.svg": 584,
	"./layout-white.svg": 585,
	"./letter.svg": 586,
	"./lineChart.svg": 303,
	"./lineChart2.svg": 304,
	"./lineChart3.svg": 305,
	"./lineChart4.svg": 306,
	"./lineChart5.svg": 330,
	"./minus.svg": 331,
	"./moedas.svg": 299,
	"./notAllowed.svg": 332,
	"./openEmail.svg": 587,
	"./opened-mail.svg": 333,
	"./openedLetter.svg": 588,
	"./pagination/paginationButton.svg": 296,
	"./plus.svg": 334,
	"./polygon.svg": 300,
	"./productCloud.svg": 589,
	"./productCloudIcon.svg": 590,
	"./rclicked-mail.svg": 335,
	"./relatorio.svg": 311,
	"./sacola.svg": 313,
	"./sacolaG.svg": 314,
	"./save.svg": 336,
	"./searchField/search.svg": 591,
	"./selectedDispatchedLetter.svg": 592,
	"./selectedLetter.svg": 593,
	"./selectedOpenedLetter.svg": 594,
	"./seller-panel.svg": 595,
	"./sellerpanel.svg": 309,
	"./semanticSearch/boosting/amazon.svg": 596,
	"./semanticSearch/boosting/americanas.svg": 597,
	"./semanticSearch/boosting/angle-down.svg": 598,
	"./semanticSearch/boosting/boosting-grey.svg": 599,
	"./semanticSearch/boosting/boosting.svg": 600,
	"./semanticSearch/boosting/casas-bahia.svg": 601,
	"./semanticSearch/boosting/magazine-luiza.svg": 602,
	"./semanticSearch/boosting/shop-time.svg": 603,
	"./semanticSearch/boosting/walmart.svg": 604,
	"./seta-azul.svg": 605,
	"./setaBranca.svg": 606,
	"./setaVerde.svg": 298,
	"./setaVermelha.svg": 607,
	"./settings.svg": 337,
	"./store.svg": 338,
	"./time.svg": 608,
	"./toggleOff.svg": 609,
	"./toggleOn.svg": 610,
	"./trash.svg": 611,
	"./trofeu.svg": 339,
	"./unavailable.svg": 315,
	"./usuarios.svg": 340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 567;